import {
  Component,
  OnDestroy,
  OnInit,
  inject,
  DOCUMENT,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { environment } from 'environments/environment';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslocoService } from '@ngneat/transloco';
import { Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit, OnDestroy {
  private titleService = inject(Title);
  private metaService = inject(Meta);
  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);

  private _document = inject(DOCUMENT);
  private _translocoService = inject(TranslocoService);
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  /**
   * Constructor
   */
  constructor() {
    const iconRegistry = this.iconRegistry;
    const sanitizer = this.sanitizer;

    this.setTitle();
    iconRegistry.addSvgIconInNamespace(
      'app',
      'balance',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/TB.svg')
    );
  }

  ngOnInit(): void {
    const activeLang = this._translocoService.getActiveLang();
    this._applyDirection(activeLang);

    this._translocoService.langChanges$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(lang => {
        this._applyDirection(lang);
      });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  setTitle(): void {}

  private _applyDirection(lang: string): void {
    const isRtl = lang === 'ae' || lang === 'ir' || lang === 'ur';
    const dir = isRtl ? 'rtl' : 'ltr';

    this._document.documentElement.dir = dir;
    if (this._document.body) {
      this._document.body.dir = dir;
      this._document.body.classList.toggle('rtl', isRtl);
      this._document.body.classList.toggle('ltr', !isRtl);
    }
  }
}
